

define(['squid/index', 'text!./template.html', 'components/xo-models/src/address/index', 'components/xo-tray-height/dist/directive', 'components/xo-page-components/src/aside-header/directive'], function (squid, template) {

    squid.module('xo-address-normalization.directive', ['squid', 'xomodel.address', 'xo-aside-header.directive', 'xomodel.address', 'xo-tray-height.directive']).directive('xoAddressNormalization', function () {
        return {
            template: template,
            scope: {
                id: '=',
                address: '=',
                doneFn: '=',
                sidebar: '=',
                hideBackButton: '='
            },
            controller: function controller($scope, $populate, $feature, $util, $AddressNormalizationModel, $timeout) {
                $util.assert($scope.address, 'Original Address cannot be empty');

                $scope.showNormalization = false;

                var normalize = $feature('addressNormalization', false, $scope.address.country);
                if (!normalize) {
                    $scope.doneFn($scope.address, false);
                    return;
                }

                var userEnteredAddress;
                var addrFormat = $feature('FormatAddressForNormalization', $scope.address.country, $scope.address.country);

                $scope.addressSelected = 'normalizedAddress';
                $scope.transitionName = 'address_normalization_normalizedAddress';

                // Brazil specific format
                if (addrFormat === 'AddressBR') {
                    userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
                    userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
                    userEnteredAddress.line2 = $scope.address.neighborhood;
                }

                $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
                $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';

                $scope.addressNormalization = new $AddressNormalizationModel({
                    id: $scope.id,
                    address: $scope.servAddress
                });

                function centerLightBox() {
                    var element = $('#lbox');
                    if (!element.length) {
                        return;
                    }

                    var windowElement = $(window);
                    var lboxContainerElem = $('#lboxContainer');
                    element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
                    element.css('width', '65%');
                    var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
                    var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
                    var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
                    if (computedLeft < leftBound) {
                        element.css('width', lboxContainerElem.width() * 0.8);
                    }
                    element.css('left', Math.max(0, elementLeft) + 'px');
                    return element;
                }

                function trinityResponseCallback() {
                    $scope.showNormalization = true;

                    // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
                    $timeout(function () {
                        centerLightBox();
                        $(window).resize(centerLightBox);
                    });
                }

                $scope.addressNormalization.save({
                    data: $scope.addressNormalization,

                    contingencies: {
                        VALIDATION_ERROR: function VALIDATION_ERROR() {
                            trinityResponseCallback();
                            $scope.transitionName = 'address_normalization_enteredAddress';
                            return;
                        }
                    },

                    success: function success(result) {
                        trinityResponseCallback();
                        if (result === false) {
                            // trinity doesn't find any match
                            $scope.transitionName = 'address_normalization_enteredAddress';
                            return;
                        }
                        $scope.normalizedAddress = result;
                        $scope.normalizedAddress.normalization_status = 'NORMALIZED';

                        if (addrFormat === 'AddressBR') {
                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
                            $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
                        }

                        // if the two addresses equal, no need to show the panel
                        if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
                            if ($scope.servAddress.preferred_address) {
                                $scope.normalizedAddress.preferred_address = true;
                            }

                            if (addrFormat === 'AddressBR' && $scope.address.line2) {
                                $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                            }
                            $scope.callback($scope.normalizedAddress, false);
                        } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
                            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
                        }
                    },

                    error: trinityResponseCallback
                });

                // make space and case insensitive. sub empty vals for undefined.
                function desensitizedAddress(addr) {
                    for (var key in addr) {
                        var val = addr[key];
                        if (addr.hasOwnProperty(key)) {
                            if (val && val.length) {
                                addr[key] = val.trim().toLowerCase();
                            } else {
                                addr[key] = undefined;
                            }
                        }
                    }
                    return addr;
                }

                // check if the two address are the same
                $scope.isEqual = function (address1, address2) {
                    var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
                    var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));

                    if (!addressOne || !addressTwo) {
                        return false;
                    }

                    return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
                };

                // Australia displays address line2 first
                $scope.isLine2First = function () {
                    return $scope.address.country === 'AU';
                };

                $scope.onBack = function () {
                    $scope.callback($scope.address, true);
                };

                $scope.selection = function (value) {
                    $scope.transitionName = 'address_normalization_' + value;
                };

                $scope.onContinue = function () {
                    $scope.addressSelected = $scope.addressNormalizationForm.addressSelected;

                    if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
                        if ($scope.servAddress.preferred_address) {
                            $scope.normalizedAddress.preferred_address = true;
                        }
                        $scope.callback($scope.normalizedAddress, false);
                    } else {
                        $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
                        if (addrFormat === 'AddressBR' && $scope.address.line2) {
                            $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
                        }
                        $scope.callback($scope.servAddress, false);
                    }
                };

                $scope.callback = function (address, isBack) {
                    $scope.doneFn(address, isBack);
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-address-components/src/address-normalization/directive.js
// module id = ./components/xo-address-components/src/address-normalization/directive.js
// module chunks = 1